/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Localized from '../../../../../../shared/components/Localized';
import Button from '../../../../../components/Button';
import { UtilityIcon } from '../../../../../components/SVGIcon';

const ModelHeader = styled.div`
display: flex;
flex-direction: column;
height: 4.75rem;
border-radius: 0.25rem;
box-shadow: 0 0.125rem 0 0 #f0f2f7;
background-color: #ffffff;
justify-content: center;
align-items: center;
@media (min-width: 20rem) and (max-width: 30rem) {
  height: 4.125rem;
}
`;
const ModelHeading = styled.p`
margin-top: 1rem;
font-family: 'Salesforce Sans';
font-size: 1.25rem;
font-weight: normal;
font-style: normal;
font-stretch: normal;
line-height: normal;
letter-spacing: normal;
text-align: center;
color: #2b2826;
@media (min-width: 20rem) and (max-width: 30rem) {
  height: 4.125rem;
  font-size: 1.125rem;
  text-align: center;
}
`;

const VerificationCodeInputHeader = styled.p`
  padding-top: 13px;
  margin-left: 96px;
  font-family: Salesforce Sans;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #2ead5dd;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 6px;
    margin-left: 16px;
  }
`;

const ModelSubHeader = styled.p`
  font-family: "Salesforce Sans";
  font-size: 12px;
  padding-bottom: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  margin-top: 8px;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #706e6b;
`;
const ModelIntro = styled.p`
  margin-top: 36px;
  margin-left: 96px;
  font-family: "Salesforce Sans";
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #706e6b;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 256px;
    color: #706e6b;
    margin-top: 18px;
    margin-left: 16px;
  }
`;
const ErrorMessage = styled.p`
  font-family: Salesforce Sans;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #c23934;
  margin-left: 96px;
  margin-top: 4px;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 6px;
    margin-left: 16px;
  }
`;
const InputLabel = styled.p`
  margin-top: 8px;
  margin-left: 96px;
  
  font-family: "Salesforce Sans";
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.5px;
  color: rgb(43, 40, 38);;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 18px;
    margin-left: 16px;
  }
`;


const BlueInputSection = styled.div`
  background: rgb(244, 246, 249);
  border-radius: 4px;
  height: 112px;
  width: 437px;
  margin-left: 96px;
  margin-top: 18px;
  @media (min-width: 320px) and (max-width: 480px) {
    min-height: 190px;
    min-width: 256px;
    max-width: 300px;
    margin-left: 16px;
  }
`;

const InputComponent = styled.input`
  background: rgb(255, 255, 255);
  border-radius: 4px;
  border: 1px solid rgb(221, 219, 218);
  height:32px;
  width: 207px;
  margin-left: 204px;
  margin-top: 16px;
`;

const VerificationInformation = styled.p`
  color: rgb(112, 110, 107);
  font-family: Salesforce Sans
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 18px;
  padding-top: 13px;
  margin-left: 16px;

`;

const PhoneNumberInput = styled.input`
  background: rgb(255, 255, 255);
  border-radius: 4px;
  border: 1px solid rgb(221, 219, 218);
  height: 33px;
  width: 237px;
  display: inline;
  margin-left: 16px;
  margin-top: 14px;
`;


const VerifyButton = styled(Button)`
  margin-left: 6px;
  height: 33px;
  margin-bottom: 3px;
  display:inline;
  font-family: "Salesforce Sans";
  font-size: 12px;
  letter-spacing: normal;
  text-align: center;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 12px;
    margin-left: 16px;
  }
`;
const SkipAnchor = styled.a`
  color: rgb(0, 112, 210);
  font-family: "Salesforce Sans";
  font-size: 13px;
  font-weight: normal;
  text-align: center;
  width: 26px;
  text-decoration:none;
  margin-left: 10px;
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
`;

// const WarningIcon = styled(UtilityIcon)`
//   margin-right: 4px;
//   margin-bottom: 4px;
// `;
class VerifyPhoneNumber extends React.Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    requests: PropTypes.object,
    onClose: PropTypes.func,
    resendVerificationCode: PropTypes.func,
    onVerificationCodeChange: PropTypes.func,
    submit: PropTypes.func,
  };

  render() {
    return (
      <div>
        <ModelHeader>
          <ModelHeading>
            <Localized modelName={'verifyPhoneNumber'} modelKey={'verifyNumberLabel'} modelAttribute={'label'} />
          </ModelHeading>

          <ModelSubHeader>
            {/* <Localized
              modelName={"instance"}
              modelKey={instanceKey}
              modelAttribute={"label"}
            /> */}
          </ModelSubHeader>
        </ModelHeader>
        <ModelIntro>
          <Localized modelName={'verifyPhoneNumber'} modelKey={'verifyNumberLabel'} modelAttribute={'label'} />
        </ModelIntro>
        <InputLabel>
          {this.props.phoneNumber !== '' ? this.props.phoneNumber : <Localized modelName={'addPhoneNumber'} modelKey={'noNumber'} modelAttribute={'label'} />}
        </InputLabel>
      
        <BlueInputSection>
          <VerificationInformation>
            <Localized modelName={'verifyPhoneNumber'} modelKey={'sentCode'} modelAttribute={'label'} /> {this.props.phoneNumber}. 
            <Localized modelName={'verifyPhoneNumber'} modelKey={'enterCode'} modelAttribute={'label'} /> 
            {" "}<a onClick = {this.props.resendVerificationCode}><Localized modelName={'verifyPhoneNumber'} modelKey={'sendAgain'} modelAttribute={'label'} /></a>
          </VerificationInformation>
          <PhoneNumberInput
            className="slds-input"
            size={10}
            maxLength={4}
            minLength={4}
            onChange={this.props.onVerificationCodeChange}
            value={this.props.verificationCode}
            onKeyPress={this.props.onKeyPress}
            placeholder="Enter the 4-digit verification code"
          />
          <VerifyButton onClick={this.props.submit}theme="neutral">
              <Localized modelName={'verifyPhoneNumber'} modelKey={'verifyButton'} modelAttribute={'label'} />
          </VerifyButton>
          <SkipAnchor onClick = {this.props.onClose}> 
              <Localized modelName={'verifyPhoneNumber'} modelKey={'skipButton'} modelAttribute={'label'} />
          </SkipAnchor>
        </BlueInputSection>
        {this.props.requests.verifyUser.isCompleted && this.props.requests.subscriber.isCompleted &&
                this.props.requests.verifyUser.value.mobileNumberVerified && (
          <div>
            {" "}
            <VerificationCodeInputHeader>
              <Localized modelName={'verifyPhoneNumber'} modelKey={'verified'} modelAttribute={'label'} />
            </VerificationCodeInputHeader>
          </div>
        )}
        {this.props.requests.verifyUser.isCompleted && 
                !this.props.requests.verifyUser.value.mobileNumberVerified && (
          <div>
            {" "}
            <ErrorMessage>
              {this.props.requests.verifyUser.response.headers['failure-reason'] ===
                'EXPIRED' && 'The authorization code has expired. Please try again.'
              }
              {this.props.requests.verifyUser.response.headers['failure-reason'] ===
                'INCORRECT' && 'The code you entered is incorrect'
              }
              {this.props.requests.verifyUser.response.headers['failure-reason'] ===
                'DUPLICATE' && 'This phone number has already been verified by another user'
              }
            </ErrorMessage>
          </div>
        )}
      </div>
    );
  }
}
export default VerifyPhoneNumber;
